import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ld-bank-linking-success',
  templateUrl: './bank-linking-success.template.html',
  styleUrls: [ './bank-linking-success.style.scss' ]
})
export class BankLinkingSuccessComponent {

  @Input() linkType: string;
  @Input() ctaText: string;
  @Input() accountType = '';
  @Output() onConfirm = new EventEmitter<void>();

  public finicityEnabled = false;

  constructor(private router: ActivatedRoute) {
    this.finicityEnabled = this.router.snapshot.data.finicityEnabled;
  }

  public finishTask(): void {
    this.onConfirm.emit();
  }
}
